import { render, staticRenderFns } from "./help-release.vue?vue&type=template&id=475710b4&scoped=true"
import script from "./help-release.vue?vue&type=script&lang=js"
export * from "./help-release.vue?vue&type=script&lang=js"
import style0 from "./help-release.vue?vue&type=style&index=0&id=475710b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475710b4",
  null
  
)

export default component.exports